import styled from "styled-components";
import {fontFamilies} from "theme/tokens";

/**
 * Externalized styles for the shared game slot (kitecorp/transferify-ui#2872): the Play offer row and
 * the placeholder the lazy game chunk replaces. Every colour reads `theme.tokens`.
 */

export const OfferRow = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 12px;
	flex-wrap: wrap;
	flex: none;
	padding: 8px 8px 8px 14px;
	border-radius: 12px;
	background: ${({theme}) => theme.tokens.field};
`;

export const OfferText = styled.p`
	margin: 0;
	min-width: 0;
	font-size: 13px;
	color: ${({theme}) => theme.tokens.ink2};
`;

/** 44px tall: the one control a phone user has to hit here. */
export const PlayButton = styled.button`
	display: inline-flex;
	align-items: center;
	gap: 8px;
	flex: none;
	min-height: 44px;
	padding: 8px 14px;
	border: 0;
	border-radius: 10px;
	background: ${({theme}) => theme.tokens.blue};
	color: ${({theme}) => theme.tokens.blueInk};
	font: 600 13px ${fontFamilies.sans};
	cursor: pointer;

	&:hover {
		background: ${({theme}) => theme.tokens.blued};
	}

	&:focus-visible {
		outline: 2px solid ${({theme}) => theme.tokens.focusOutline};
		outline-offset: 2px;
	}

	svg {
		width: 12px;
		height: 12px;
		flex: none;
	}
`;

/** Holds the picked game's exact height while its chunk loads, so nothing below it jumps. */
export const GameFallback = styled.div<{$height: number}>`
	position: relative;
	height: ${({$height}) => $height + 2}px;
	flex: none;
	border-radius: 14px;
	background: ${({theme}) => theme.tokens.field};
	border: 1px solid ${({theme}) => theme.tokens.fieldLine};
`;
